import { collect } from "collect.js";
import { useFormatsMoney } from "./FormatsMoney";
import GlobalEventBus from "../EventBus/GlobalEventBus";
import { useCustomerStore } from "../stores/CustomerStore";
import { defineStore } from "pinia";
import { Price, ProductVariable } from "@daalder/types";
import { usePriceHelper } from "./PriceHelper";

const { formatMoney } = useFormatsMoney();
let customerStore: Omit<ReturnType<typeof useCustomerStore>, keyof ReturnType<typeof defineStore>> = null;

/**
 * @description This composable contains methods specifically for calculating (not formatting!) discounts. This
 * composable is a layer on top of the PriceHelper composable to prevent cluttering the PriceHelper with methods that
 * are more abstract than fetching prices from a collection.
 */
export function useDiscountHelper() {
    const { getPrice, getListPrice, getOriginalPrice } = usePriceHelper();

    function getUnitPriceExclDiscounts(prices: Price[]): number | null {
        let unitPriceExclDiscounts: number = +getListPrice(prices, 1);

        if (!(unitPriceExclDiscounts > 0)) {
            unitPriceExclDiscounts = +getOriginalPrice(prices, 1);
        }

        if (!(unitPriceExclDiscounts > 0)) {
            unitPriceExclDiscounts = +getPrice(prices, 1);
        }

        if (!(unitPriceExclDiscounts > 0)) {
            return null;
        }

        return +unitPriceExclDiscounts;
    }

    function getUnitPriceInclDiscounts(prices: Price[], amount: number): number | null {
        let unitPriceInclDiscounts: number = +getPrice(prices, amount);

        if (!(unitPriceInclDiscounts > 0)) {
            return null;
        }

        return unitPriceInclDiscounts;
    }

    return {
        getUnitPriceExclDiscounts,
        getUnitPriceInclDiscounts,
    };
}
